import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { Location } from "@typings/entities/location";

async function getLocationById(id: string): Promise<Location> {
  const response = await apiClient.get<Location>(
    apiPaths.locations.getById(id),
  );
  return response.data;
}

export function useGetLocationById(
  locationId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    locationId ? [`fetch-location-${locationId}`] : null,
    () => getLocationById(locationId!),
    options,
  );
}
